/* eslint-disable import/first */
import React, { useEffect } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { useNavigate } from '@reach/router';
import { useIntl } from 'react-intl';
const { logout, selectLoginStatus } = Slices.authSlice;
const { clearAddress } = Slices.addressSlice;
const { clearState } = Slices.orderSlice;

function Logout({ path, locale, retUrl = '/' }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const intl = useIntl();
  const isLoggedIn = useSelector(selectLoginStatus);
  const [status, setStatus] = React.useState('initial');
  if (status === 'initial') {
    dispatch(logout());
    dispatch(clearAddress());
    dispatch(clearState());
    setStatus('loaded');
    navigate(`/${intl.locale}/home`);
  }
  useEffect(() => {
    if (!isLoggedIn) {
      navigate(`/${intl.locale}/home`);
    }
  }, [intl.locale, isLoggedIn, navigate, retUrl]);

  return <div></div>;
}

export default Logout;
